<template>
  <div class="main">
    <div class="c_tit mt30 fl" style="width:180px;"><p>友情链接<span>LINKS</span></p></div>
    <div class="Select fl">
      <select onchange="window.open(this.options[this.selectedIndex].value,'_blank')">
        <option>–请选择–</option>
        <option value="">池州职业技术学院官网</option>
        <option value="http://www.czu.edu.cn/">池州学院</option>
        <option value="http://www.aqvtc.cn/">安庆职业技术学院</option>
        <option value="http://www.tlpt.net.cn/">铜陵职业技术学院</option>
        <option value="http://www.uta.edu.cn/">安徽职业技术学院</option>
      </select>
    </div>
  </div>
</template>
<script>
    export default {
        name: "footComp"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/footComp.vue